<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-form-group label="Public listings">
          <b-form-checkbox
            :disabled="searchPage"
            v-model="$store.state.priConfigrationforms.publicListings.matchExact"
          >Match Exact</b-form-checkbox>
          <b-form-checkbox
            :disabled="searchPage"
            v-model="$store.state.priConfigrationforms.publicListings.matchPartial"
          >Match Partial</b-form-checkbox>
          <b-form-checkbox
            :disabled="searchPage"
            v-model="$store.state.priConfigrationforms.publicListings.matchSimilar"
          >Match Similar</b-form-checkbox>
          <b-form-checkbox
            :disabled="searchPage"
            v-model="$store.state.priConfigrationforms.publicListings.stopWords"
          >Remove stop words</b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <div>
          <p>Copy Stop Words</p>
          <b-input-group class="mt-3">
            <template v-slot:prepend>
              <b-button
                variant="outline-warning"
                @click="copyAllStopWords"
                :disabled="searchPage"
                style="height:35px;"
              >Add All</b-button>
            </template>
            <v-select
              size="sm"
              :searchable="true"
              :clearable="true"
              :multiple="true"
              :disabled="searchPage"
              label="text"
              v-model="selectStopWords"
              :options="stopWordsList"
              style="width: 72%;"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  @focus="copyStopWords()"
                />
              </template>
            </v-select>
            <b-input-group-append>
              <b-button
                variant="outline-warning"
                :disabled="searchPage"
                @click="pasteStopWords"
                style="height:35px;"
              >Add</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="mt-3">
          <b-form-checkbox
            :disabled="searchPage"
            v-model="$store.state.priConfigrationforms.publicListings.disableRemovalText"
          >Disable the removal of text in (Text)</b-form-checkbox>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-left">
        <b-card>
          <h4>Stop Keywords</h4>
          <b-input-group class="mt-3">
            <b-form-input
              :disabled="searchPage"
              placeholder="Enter the phrases you would like to be removed from the search string..."
              @keyup.enter="addStopWords()"
              v-model="addStopWord"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="searchPage" @click="addStopWords" variant="outline-warning">Add</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-table
            :items="$store.state.priConfigrationforms.publicListings.stopWordsList"
            :fields="fieldsKeywords"
          >
            <template v-slot:cell(text)="data">
              <p>{{data.item}}</p>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                :disabled="searchPage"
                @click="removeStopWords(data)"
                variant="danger"
                size="sm"
              >
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "PublicListingComponent",
  data() {
    return {
      copyingStopWords: false,
      addStopWord: null,
      fieldsKeywords: [
        { key: "text", label: "Keyword" },
        { key: "Actions", label: "Actions" }
      ],
      selectStopWords: [],
      stopWordsList: []
    };
  },
  methods: {
    copyStopWords() {
      this.stopWordsList = [];
      if (
        this.$store.state.priConfigrationforms.futureRisks.categories.length > 0
      ) {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.stopWords.map(stopWordsData => {
              this.stopWordsList.push({
                text: stopWordsData,
                value: stopWordsData
              });
            });
          }
        );
      }
      if (
        this.$store.state.priConfigrationforms.negativeMedia.categories.length >
        0
      ) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.stopWords.map(stopWordsData => {
              this.stopWordsList.push({
                text: stopWordsData,
                value: stopWordsData
              });
            });
          }
        );
      }
    },
    copyAllStopWords() {
      let stopWordsData = [];
      if (
        this.$store.state.priConfigrationforms.negativeMedia.categories.length >
        0
      ) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.stopWords.map(stopWordsValue => {
              stopWordsData.push(stopWordsValue);
            });
          }
        );
      }
      if (
        this.$store.state.priConfigrationforms.futureRisks.categories.length > 0
      ) {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.stopWords.map(stopWordsValue => {
              stopWordsData.push(stopWordsValue);
            });
          }
        );
      }

      stopWordsData.map(value => {
        this.$store.state.priConfigrationforms.publicListings.stopWordsList.unshift(
          value
        );
      });
    },
    pasteStopWords() {
      this.selectStopWords.map(value => {
        this.$store.state.priConfigrationforms.publicListings.stopWordsList.unshift(
          value.text
        );
      });
      this.stopWordsList = [];
      this.selectStopWords = [];
    },
    copyFutureRisksStopWords() {
      this.copyingFutureRisks = true;
      this.$store.state.priConfigrationforms.futureRisks.categories.map(
        futureRisksCategoriesData => {
          futureRisksCategoriesData.stopWords.map(stopWordData => {
            this.futureRisksStopWordsList.push(stopWordData);
          });
        }
      );
    },
    addCopiedFutureRisksStepWords(data) {
      this.$store.state.priConfigrationforms.publicListings.stopWordsList.unshift(
        data.item
      );
      let stopWordsIndex = this.futureRisksStopWordsList.indexOf(data.item);
      this.futureRisksStopWordsList.splice(stopWordsIndex, 1);
    },
    addStopWords() {
      if (this.addStopWord) {
        let stopWordsData = this.$store.state.priConfigrationforms
          .publicListings.stopWordsList;
        stopWordsData.unshift(this.addStopWord);
      }
      this.addStopWord = null;
    },
    removeStopWords(data) {
      let stopWordsData = this.$store.state.priConfigrationforms.publicListings
        .stopWordsList;
      let stopWordsIndex = stopWordsData.indexOf(data.item);
      stopWordsData.splice(stopWordsIndex, 1);
    }
  },
  props: {
    searchPage: Boolean
  }
};
</script>